import request from '@/utils/request'

const base = '/webserver/waybill/vehicleMonitor'
export async function queryVehicle(mode, data) {
  const paths = { positions: 'position', tracks: 'tracks', network: 'network' }
  if (!paths[mode]) throw new Error('不支持的车辆查询')
  try { return (await request.post(`${base}/${paths[mode]}`, data)).data }
  catch (error) { throw new Error(error.msg || error.message || '车辆查询失败') }
}

export async function exportVehicleTracks(snapshot) {
  try {
    const response = await request.post(`${base}/tracks/export`, snapshot, { responseType: 'blob', timeout: 120000 })
    if ((response.headers['content-type'] || '').includes('json')) {
      const error = JSON.parse(await response.data.text())
      throw new Error(error.msg || '导出失败')
    }
    return response.data
  } catch (error) {
    if (error.response && error.response.data instanceof Blob) {
      const body = JSON.parse(await error.response.data.text())
      throw new Error(body.msg || '导出失败')
    }
    throw new Error(error.msg || error.message || '导出失败')
  }
}
